module.exports = __webpack_public_path__ + "fonts/MyriadPro-Regular.726147a.woff2";